import { useUserContext } from '../contexts/UserContext';
import { useNotification } from './useNotifications';

type FreeTierMessageType = 'action' | 'statistic';

export function useFreeTierNotification() {
  const { isInstaller } = useUserContext();
  const addNotification = useNotification();

  const _getMessage = (type: FreeTierMessageType = 'action') =>
    ({
      action: `Actions are not permitted on 'Free' tier - ${isInstaller ? 'upgrade today' : ' please contact your installer'} `,
      statistic: `The selected granularity is not available on 'Free' tier - ${isInstaller ? 'upgrade today' : ' please contact your installer'} `,
    })[type];

  const showFreeTierMessage = (type?: FreeTierMessageType) =>
    addNotification('info', _getMessage(type));

  return showFreeTierMessage;
}
